import baseUrls from '../baseURLs.json'
import Vue from 'vue'
import i18n from '../i18n.js'
import Store from '../store/store.js'
import PNotify from 'pnotify/dist/es/PNotify'
import ignored from 'print-js'
// eslint-disable-next-line
import PNotifyButtons from 'pnotify/dist/es/PNotifyButtons'
// eslint-disable-next-line
import PNotifyStyleMaterial from 'pnotify/dist/es/PNotifyStyleMaterial.js'
// eslint-disable-next-line
import PNotifyAnimate from 'pnotify/dist/es/PNotifyAnimate'

export const getBaseUrl = () => {
  return baseUrls.base
}

export const getCountryName = countryId => {
  let country = Store.getters['locale/getCountriesList'].filter(c => c.value === countryId)[0]
  return country ? country.text : '-'
}

export const formatDateAsMonthYear = theDate => {
  if (!theDate) {
    return ''
  }
  if (Store.getters['locale/isRtl']) {
    return Vue.moment(theDate).format('YYYY-MMMM')
  } else {
    return Vue.moment(theDate).format('YYYY-MMMM')
  }
}

export const reFormatDateFromMonthYear = theDate => {
  if (!theDate) {
    return ''
  }
  let sp = theDate.split('-')
  let year = sp[0]
  let month = sp[1].toLowerCase()
  // no matter what the day is because we only need the format to be like year-month-day
  // and finally we just take year and month
  // so I put 01 as the first date of the month
  let day = '01'
  Store.getters['misc/getMonthListEn'].forEach(m => {
    if (m.text === month) {
      month = m.value
      return true
    }
  })

  return year + '-' + month + '-' + day
}

export const formatTimeForDisplay = theTime => {
  let hour = theTime.split(':')[0]
  let minute = theTime.split(':')[1]
  hour = Number(hour)
  let amOrpm = ''
  let formattedTime = ''
  if (hour > 12) {
    hour = hour - 12
    amOrpm = 'PM'
  } else {
    amOrpm = 'AM'
  }
  if (hour === 0) {
    hour = 12
    amOrpm = 'AM'
  } else if (hour === 12) {
    amOrpm = 'PM'
  }

  formattedTime = hour + ':' + minute + ' ' + amOrpm
  return formattedTime
}

// eslint-disable-next-line no-unused-vars
export const userHasPermissions = actions => {
  const systemActions = Store.getters['auth/getAuthUserData'].actions_permissions

  if (systemActions === undefined) return false

  for (let index = 0; index < actions.length; index++) {
    if (systemActions.includes(actions[index])) {
      return true
    }
  }

  return false
}

export const userHasSidebarPermissions = permissionId => {
  const permissions = Store.getters['auth/getAuthUserData'].sidebar_permissions
  if (permissions === undefined) return false

  return permissions.includes(permissionId)
}

export const newLineToBreakLine = str => {
  return str ? str.replace(/\n/g, '<br>') : ''
}

// Check if ID is an integer
export const checkId = id => {
  if (!Number.isInteger(id) || id <= 0) {
    let theError = 'ID must be an integer and greater than 0'
    ktNotify({ type: 'error', text: theError })
    return false
  }
  return true
}

// Display Store.Actions Errors
export const showErrorMessage = (error, message = '') => {
  if (error) {
    Store.dispatch('errors/errorHandling', { err: error, msg: message }, { root: true })
  }
}

export const doPrinting = (isInvoice = false) => {
  let onlyForPrint = document.querySelectorAll('.only-for-print')
  let notPrintable = document.querySelectorAll('.not-printable')
  let invoiceContent = document.querySelector('.invoice-content')
  let theDialogContent = document.querySelector('.view-dialog-content')
  theDialogContent.classList.remove('grey')
  invoiceContent.style.marginTop = '90px'
  notPrintable.forEach(element => {
    element.style.display = 'none'
  })
  onlyForPrint.forEach(element => {
    element.style.display = 'block'
  })
  if (isInvoice) {
    document.querySelector('.printed-table').style.marginTop = '-90px'
  }
  // eslint-disable-next-line
  $('#printArea').printThis({
    importCSS: true,
    importStyle: true
  })
  setTimeout(() => {
    theDialogContent.classList.add('grey')
    invoiceContent.style.marginTop = '0px'
    onlyForPrint.forEach(element => {
      element.style.display = 'none'
    })
    notPrintable.forEach(element => {
      element.style.display = 'flex'
    })
    if (isInvoice) {
      document.querySelector('.printed-table').style.marginTop = '0px'
    }
  }, 350)

  // ***********************  OLD PRINT  ***********************
  // let theDialog = document.querySelector('.v-dialog')
  // let theDialogCard = document.querySelector('#printArea')
  // let theDialogContent = document.querySelector('.view-dialog-content')
  // let notPrintable = document.querySelectorAll('.not-printable')
  // let onlyForPrint = document.querySelectorAll('.only-for-print')

  // notPrintable.forEach(element => {
  //   element.style.display = 'none'
  // })
  // onlyForPrint.forEach(element => {
  //   element.style.display = 'block'
  // })

  // theDialog.classList.add('remove-box-shadow')
  // theDialogCard.classList.add('remove-box-shadow')
  // theDialogContent.classList.remove('grey')

  // printJS({
  //   printable: 'printArea',
  //   type: 'html',
  //   documentTitle: '',
  //   targetStyles: ['*']
  // })

  // notPrintable.forEach(element => {
  //   element.style.display = 'flex'
  // })
  // onlyForPrint.forEach(element => {
  //   element.style.display = 'none'
  // })

  // theDialogContent.classList.add('grey')
  // theDialog.classList.remove('remove-box-shadow')
  // theDialogCard.classList.remove('remove-box-shadow')
}

// When switching UI direction, notification will only change position after full page reload!!
export const ktNotify = payload => {
  let rtl = Store.getters['locale/isRtl']
  let xAnimationIn = rtl ? 'fadeInLeft' : 'fadeInRight'
  let xAnimationOut = rtl ? 'fadeOutLeft' : 'fadeOutRight'
  let xPosition = rtl ? 'right' : 'left'

  // Time must be a number represented in milliseconds, if not provided or not a number, default is 3000ms
  let timer = typeof payload.time === 'number' ? Math.abs(payload.time) : 1000

  // for rtl text if it's needed we have to use <span dir="rtl">text here</span> in the translation in the json file
  // also for specific font for certain languages we add (style="font-family: ...") attribute in the translation
  // so e.g: arabic, <span dir="rtl" style="font-family:Noto Kufi Arabic'">نموذج نص.</span>

  if (typeof window.stackModal === 'undefined') {
    window.stackModal = {
      dir1: 'down',
      dir2: xPosition,
      firstpos1: 70,
      firstpos2: 5,
      push: 'bottom'
    }
  }
  var opts = {
    icon: false,
    textTrusted: true,
    text: i18n.t(payload.text),
    stack: window.stackModal,
    modules: {
      Buttons: {
        sticker: false
      },
      Animate: {
        animate: true,
        inClass: xAnimationIn,
        outClass: xAnimationOut
      }
    }
  }
  PNotify.defaults.delay = timer
  // Set default styling, also use material icons
  PNotify.defaults.styling = 'material'
  PNotify.defaults.icons = 'material'

  switch (payload.type) {
    case 'error':
      PNotify.error(opts)
      break
    case 'info':
      PNotify.info(opts)
      break
    case 'success':
      PNotify.success(opts)
      break
    default:
      PNotify.notice(opts)
  }
}
